import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'undefined-logout',
  template: require('./logout.component.html')
})
export class LogoutComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    localStorage.clear();
    this.router.navigate(['/admin/login']);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/logout/logout.component.ts